<template>
  <div class="comment-actions">
    <!-- 点赞按钮 - 爱心 -->
    <button
        @click="upvote(comment.id)"
        class="action-btn like-btn"
        :class="{ 'active': isLiked }"
        aria-label="点赞"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path v-if="!isLiked" fill="none" stroke="currentColor" stroke-width="1.8"
              d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        <path v-else fill="currentColor"
              d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
      <span class="count">{{ likeCount }}</span>
    </button>

    <!-- 点踩按钮 - 你提供的心碎SVG -->
    <button
        @click="toggleDislike"
        class="action-btn dislike-btn"
        :class="{ 'active': isDisliked }"
        aria-label="点踩"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024">
        <path v-if="!isDisliked" d="M208.938667 120.874667C300.501333 79.018667 412.288 90.88 512 176.085333c99.712-85.205333 211.498667-97.066667 303.061333-55.210666C913.621333 165.888 981.333333 270.165333 981.333333 389.845333c0 117.077333-48.896 206.250667-112.213333 277.546667-50.432 56.746667-112 104.192-165.546667 145.408l-0.341333 0.298667c-12.202667 9.386667-23.978667 18.432-35.2 27.306666-21.76 17.109333-45.781333 35.968-70.314667 50.304-24.490667 14.293333-53.546667 26.624-85.717333 26.624s-61.226667-12.288-85.76-26.624c-24.490667-14.336-48.512-33.194667-70.272-50.346666-11.221333-8.832-22.997333-17.92-35.2-27.306667l-0.341333-0.256c-53.589333-41.216-115.114667-88.618667-165.546667-145.408C91.562667 596.053333 42.666667 506.88 42.666667 389.845333c0-119.68 67.754667-223.957333 166.272-268.970666z m293.546666 228.266666l119.637334 85.461334a42.666667 42.666667 0 0 1 7.594666 62.506666l-102.272 119.338667 57.386667 57.386667a42.666667 42.666667 0 0 1 11.221333 40.533333l-22.613333 90.624c12.928-9.045333 26.666667-19.712 41.813333-31.616 12.416-9.813333 25.088-19.626667 37.76-29.397333h0.042667c53.674667-41.386667 107.733333-83.072 152.277333-133.248C859.093333 550.144 896 480.298667 896 389.845333c0-87.765333-49.578667-160.853333-116.394667-191.36-63.061333-28.842667-148.778667-22.784-232.448 61.269334l-44.672 89.386666zM244.394667 198.485333C177.578667 229.034667 128 302.08 128 389.845333c0 90.453333 36.864 160.298667 90.666667 220.885334 44.544 50.176 98.645333 91.904 152.32 133.248 12.672 9.813333 25.344 19.541333 37.802666 29.397333 22.528 17.749333 41.984 32.810667 60.544 43.648 4.053333 2.389333 7.893333 4.437333 11.52 6.229333l26.581334-106.154666-68.266667-68.266667a42.666667 42.666667 0 0 1-2.218667-57.941333l97.664-113.92-111.402666-79.573334a42.666667 42.666667 0 0 1-13.354667-53.802666l49.92-99.84c-78.08-68.693333-156.501333-72.192-215.381333-45.269334z" :fill="isDisliked ? '#1890ff' : '#707070'"/>
        <path v-else d="M208.938667 120.874667C300.501333 79.018667 412.288 90.88 512 176.085333c99.712-85.205333 211.498667-97.066667 303.061333-55.210666C913.621333 165.888 981.333333 270.165333 981.333333 389.845333c0 117.077333-48.896 206.250667-112.213333 277.546667-50.432 56.746667-112 104.192-165.546667 145.408l-0.341333 0.298667c-12.202667 9.386667-23.978667 18.432-35.2 27.306666-21.76 17.109333-45.781333 35.968-70.314667 50.304-24.490667 14.293333-53.546667 26.624-85.717333 26.624s-61.226667-12.288-85.76-26.624c-24.490667-14.336-48.512-33.194667-70.272-50.346666-11.221333-8.832-22.997333-17.92-35.2-27.306667l-0.341333-0.256c-53.589333-41.216-115.114667-88.618667-165.546667-145.408C91.562667 596.053333 42.666667 506.88 42.666667 389.845333c0-119.68 67.754667-223.957333 166.272-268.970666z m293.546666 228.266666l119.637334 85.461334a42.666667 42.666667 0 0 1 7.594666 62.506666l-102.272 119.338667 57.386667 57.386667a42.666667 42.666667 0 0 1 11.221333 40.533333l-22.613333 90.624c12.928-9.045333 26.666667-19.712 41.813333-31.616 12.416-9.813333 25.088-19.626667 37.76-29.397333h0.042667c53.674667-41.386667 107.733333-83.072 152.277333-133.248C859.093333 550.144 896 480.298667 896 389.845333c0-87.765333-49.578667-160.853333-116.394667-191.36-63.061333-28.842667-148.778667-22.784-232.448 61.269334l-44.672 89.386666zM244.394667 198.485333C177.578667 229.034667 128 302.08 128 389.845333c0 90.453333 36.864 160.298667 90.666667 220.885334 44.544 50.176 98.645333 91.904 152.32 133.248 12.672 9.813333 25.344 19.541333 37.802666 29.397333 22.528 17.749333 41.984 32.810667 60.544 43.648 4.053333 2.389333 7.893333 4.437333 11.52 6.229333l26.581334-106.154666-68.266667-68.266667a42.666667 42.666667 0 0 1-2.218667-57.941333l97.664-113.92-111.402666-79.573334a42.666667 42.666667 0 0 1-13.354667-53.802666l49.92-99.84c-78.08-68.693333-156.501333-72.192-215.381333-45.269334z" fill="#1890ff"/>
      </svg>
      <span class="count">{{ dislikeCount }}</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    initialLikes: { type: Number, default: 0 },
    initialDislikes: { type: Number, default: 0 },
    commentId: { type: Number, required: true }
  },
  data() {
    return {
      isLiked: false,
      isDisliked: false,
      likeCount: this.initialLikes,
      dislikeCount: this.initialDislikes
    }
  },
  methods: {
    toggleLike() {
      if (this.isLiked) {
        this.likeCount--
        this.isLiked = false
      } else {
        this.likeCount++
        this.isLiked = true
        if (this.isDisliked) {
          this.dislikeCount--
          this.isDisliked = false
        }
      }
      this.updateVoteStatus()
    },
    toggleDislike() {
      if (this.isDisliked) {
        this.dislikeCount--
        this.isDisliked = false
      } else {
        this.dislikeCount++
        this.isDisliked = true
        if (this.isLiked) {
          this.likeCount--
          this.isLiked = false
        }
      }
      this.updateVoteStatus()
    },
    updateVoteStatus() {
      console.log(`更新评论 ${this.commentId} 的投票状态:`, {
        likes: this.likeCount,
        dislikes: this.dislikeCount
      })
    }
  }
}
</script>

<style scoped>
.comment-actions {
  display: flex;
  gap: 18px;
  margin-top: 10px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 24px;
  transition: all 0.25s ease;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.action-btn svg {
  width: 20px;
  height: 20px;
  transition: all 0.25s ease;
}

.like-btn svg {
  color: #777;
}

.like-btn.active svg {
  color: #ff4d4f;
}

.dislike-btn svg {
  color: #777;
}

.dislike-btn.active svg {
  color: #1890ff;
}

.count {
  font-size: 15px;
  min-width: 18px;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-weight: 400;
}

.like-btn.active .count {
  color: #ff4d4f;
  font-weight: 600;
}

.dislike-btn.active .count {
  color: #1890ff;
  font-weight: 600;
}
</style>